// Controlled by the VUE_APP_SERVICE_SUSPENDED env var (set per app in the Amplify console).
// When 'true', every route is redirected to the suspended service page, regardless of the realm/theme.
export const SUSPENDED_SERVICE_PATH = '/servico-suspenso';

export const isServiceSuspended = process.env.VUE_APP_SERVICE_SUSPENDED === 'true';
